"use strict";
// Maintain this list of Z-indexes so that we can always reference the relative values, and create space inbetween existing components if necessary
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRADIENT_FALLBACK_ORANGE = exports.AMZN_GRADIENT = exports.GREY_10 = exports.GREY_50 = exports.SQUID_MEDIUM = exports.SQUID_INK = exports.BOX_SHADOW_COMPONENT = exports.MOBILE_SETUP = exports.Z_INDEX = void 0;
exports.Z_INDEX = {
    SUB_HEADER: 2,
    FOOTER: 5,
    HEADER: 7,
    SIDE_NAV: 10,
    LOADING_OVERLAY: 1000,
};
exports.MOBILE_SETUP = {
    mobile: {
        mediaQuery: '(max-width: 750px)',
    },
};
exports.BOX_SHADOW_COMPONENT = 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px';
// TODO - Remove once available via Storm https://issues.amazon.com/issues/AAPN-4795
exports.SQUID_INK = '#232f3f';
exports.SQUID_MEDIUM = '#f6f7f9';
exports.GREY_50 = '#f2f4f6';
exports.GREY_10 = '#fBfBfC';
exports.AMZN_GRADIENT = 'linear-gradient(90deg, rgba(255,90,0,1) 0%, rgba(255,132,65,1) 50%, rgba(255,154,115,1) 100%)';
exports.GRADIENT_FALLBACK_ORANGE = '#ff5a00';
